export default __webpack_public_path__ + "static/media/MQ.63da048c.svg";